/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-var-requires */
// Require is necessary for image require
// TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
/* eslint-disable global-require */
// eslint-disable-next-line no-unused-vars
import { getStateFromPath } from '@react-navigation/native';
import path from 'path';
import { modelType } from '@24i/st-api-connector';
import createOnboardingItem from './runtime/Page/Onboarding/createOnboardingItem';
import { Device, getActualWidth } from './DeviceUtils/DeviceUtils';
import VersionAsciiText from './versionAscii';

const ENDPOINTS = require('../platformAssets/endpoints.json');
const APP_INFO = require('../platformAssets/runtime/appInfo.json');

const RUNTIME_CONFIG = require('../platformAssets/renative.runtime.json');

export const APP_THEME = RUNTIME_CONFIG?.theme || {};
export const APP_METADATA = RUNTIME_CONFIG?.meta || {};
export const APP_VERSION = APP_INFO.version;

// this log is here on purpose to help testers
console.log(`${VersionAsciiText} \n ${APP_VERSION}`);
if (process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test') {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    console.log = () => {};
}

export const HIDE_REGISTRATION_BUTTON = APP_INFO?.hideRegistrationButton || false;

export const PLAYER_FADE_IN_DURATION = 100;
export const ROTATION_WAIT_DURATION = Device.isIos ? 400 : 100;

export const isTMCZEnv = RUNTIME_CONFIG?.meta?.vendorName === 'T-Mobile' || false;
export const isMagioEnv = RUNTIME_CONFIG?.meta?.vendorName === 'Slovak Telekom' || false;

export const MAX_INTERNET_CONNECTION_TRIES = 10;

export const MAX_WEB_WIDTH = getActualWidth() < 1280 ? getActualWidth() : 1280;

export const MAX_USED_RECORDING_SPACE = 90;

export const DEFAULT_LANGUAGE = 'en';
export const MCORE_SUPPORTED_LANGUAGES = ['en', 'sk', 'cz'];
export const MCORE_LAB_URI = 'http://ottlab.magio.tv:1027';
let ENDPOINT = Device.isIos ? ENDPOINTS.ios : ENDPOINTS.android;
if (Device.isWeb) ENDPOINT = ENDPOINTS.web;

export const MCORE_URI = MCORE_LAB_URI;
export const BACKSTAGE_ID = ENDPOINT?.backstageServiceId;
export const BACKSTAGE_URI = 'https://backstage-api.com';
export const BACKSTAGE_APP_ID = ENDPOINT?.appId;
export const AD_PROVIDER_URI = 'https://ads-sk.devcdn.magio.tv';

export const PLATFORMS = Object.freeze({
    VOYO: 'VOYO',
    CANALPLUS: 'CANALPLUS'
});

export const PageItemTypeEnum = Object.freeze({
    SINGLE_ROW: 'single_row',
    SLIDER: 'slider',
    SINGLE_HIGHLIGHT: 'single_highlight',
    DOUBLE_ROW: 'double_row'
});

export const DAY_MILLISECONDS = 86400000;
export const TIMESEEK_END_OFFSET = 5;
export const TIMESHIFT_EPG_OFFSET_MILLIS = 36000000;
export const REFRESH_CAROUSEL_MILLIS = 30000;
export const HIDE_PLAYER_UI_TIMEOUT = Device.isWeb ? 3000 : 6000;

export const MINIMUM_SEARCH_QUERY_LENGTH = 3;
export const PIN_LENGTH = 4;
export const SHOWTIMES_END_TIME_OFFSET = 604800000;

export const RECORDING_BINGE_WATCHING_DAYS_LIMIT = 7;

export const DEFAULT_PARENTAL_CONTROL_SETTINGS = {
    // Enabled says that whole settings are enabled
    enabled: true,
    rating: '18',
    lockUnratedContent: false,
    hideAdultChannels: false,
    lockAdultContent: true,
    // Unlocked means temporarily unlocked by entering pin
    unlocked: false
};

export const DEFAULT_PLAYLIST_PARAMS = {
    fromMs: Date.now(),
    toMs: Date.now() + DAY_MILLISECONDS
};

export const STREAM_TYPE = Object.freeze({
    LIVE: <const>'LIVE',
    ARCHIVE: <const>'ARCHIVE',
    // TIMESHIFT: <const>'TIMESHIFT',
    VOD: <const>'VOD',
    DVR: <const>'DVR'
});

export const EPG_LIST_TYPES = {
    ALL: 'all',
    LIVE: 'live',
    FAVORITES: 'favorites'
};
// From ST side is not clear how default list types should work so:

// This is for mini epg
export const DEFAULT_MINI_EPG_LIST_MODE = EPG_LIST_TYPES.LIVE;
// This is for normal epg
export const DEFAULT_LIST_MODE = EPG_LIST_TYPES.LIVE;

export const VOD_PLACEHOLDER = require('../platformAssets/runtime/images/vod-placeholder.png');
export const TV_PLACEHOLDER = require('../platformAssets/runtime/images/tv-placeholder.png');
export const PERSON_PLACEHOLDER = require('../platformAssets/runtime/images/person-placeholder.png');
export const PROMO_CAROUSEL_MASK = require('../platformAssets/runtime/images/mask.png');

export const SIMPLE_NOTIFICATION_PORTRAIT_BACKGROUND = require('../platformAssets/runtime/simpleNotifications/notification_bcg_portrait.jpg');
export const SIMPLE_NOTIFICATION_LANDSCAPE_BACKGROUND = require('../platformAssets/runtime/simpleNotifications/notification_bcg_landscape.jpg');

export const ENTITLEMENTS_BACKGROUND_PORTAIT = require('../platformAssets/runtime/entitlements/bg-entitlements_portrait.png');
export const ENTITLEMENTS_BACKGROUND_LANDSCAPE = require('../platformAssets/runtime/entitlements/bg-entitlements_landscape.png');

export const BINGE_WATCHING_VOD_DURATION = 5;
export const BINGE_WATCHING_END_SECONDS_LIMIT = 10;
export const BINGE_WATCHING_LOADING_DURATION = 5000;

const ONBOARDING_SOURCES = {
    FOREGROUND_IMAGE: {
        TABLET: require('../platformAssets/runtime/images/onboarding-Tablet_pattern.png'),
        MOBILE: require('../platformAssets/runtime/images/onboarding-Mobile_pattern.png')
    },
    IMAGES: [
        {
            TABLET: require('../platformAssets/runtime/images/onboarding-1-Tablet_image.png'),
            MOBILE: require('../platformAssets/runtime/images/onboarding-Mobile_step1_image.png')
        },
        {
            TABLET: require('../platformAssets/runtime/images/onboarding-2-Tablet_image.png'),
            MOBILE: require('../platformAssets/runtime/images/onboarding-Mobile_step2_image.png')
        },
        {
            TABLET: require('../platformAssets/runtime/images/onboarding-3-Tablet_image.png'),
            MOBILE: require('../platformAssets/runtime/images/onboarding-Mobile_step3_image.png')
        },
        {
            TABLET: require('../platformAssets/runtime/images/onboarding-4-Tablet_image.png'),
            MOBILE: require('../platformAssets/runtime/images/onboarding-Mobile_step4_image.png')
        },
        {
            TABLET: require('../platformAssets/runtime/images/onboarding-5-Tablet_image.png'),
            MOBILE: require('../platformAssets/runtime/images/onboarding-Mobile_step5_image.png')
        }
    ]
};

export const ONBOARDING_CONFIG = {
    foregroundImage: ONBOARDING_SOURCES.FOREGROUND_IMAGE[Device.isTablet ? 'TABLET' : 'MOBILE'],
    items: [
        createOnboardingItem(
            ONBOARDING_SOURCES.IMAGES[0][Device.isTablet ? 'TABLET' : 'MOBILE'],
            'COMMON.ONBOARDING_TEXT1'
        ),
        createOnboardingItem(
            ONBOARDING_SOURCES.IMAGES[1][Device.isTablet ? 'TABLET' : 'MOBILE'],
            'COMMON.ONBOARDING_TEXT2'
        ),
        createOnboardingItem(
            ONBOARDING_SOURCES.IMAGES[2][Device.isTablet ? 'TABLET' : 'MOBILE'],
            'COMMON.ONBOARDING_TEXT3'
        ),
        createOnboardingItem(
            ONBOARDING_SOURCES.IMAGES[3][Device.isTablet ? 'TABLET' : 'MOBILE'],
            'COMMON.ONBOARDING_TEXT4'
        ),
        createOnboardingItem(
            ONBOARDING_SOURCES.IMAGES[4][Device.isTablet ? 'TABLET' : 'MOBILE'],
            'COMMON.ONBOARDING_TEXT5',
            'COMMON.ONBOARDING_BTN_EXPLORE'
        )
    ]
};

export const firebaseConfig = APP_INFO.firebaseConfig || {};

export const RECORDINGS_TYPE = Object.freeze({
    MY_RECORDINGS: 'MY_RECORDINGS',
    PLANNED_RECORDINGS: 'PLANNED_RECORDINGS',
    IPTV_RECORDINGS: 'IPTV_RECORDINGS'
});

export const MAX_PIN_TRIES = 3;

export const PIN_BLOCKED_TIME = 120000;

export const DEFAULT_TV_LIST_LIMIT = 20; // this should be tested out
export const DEFAULT_TV_LIST_WEB_LIMIT = 50;

// could be used enum but not the best practice
export const DETAIL_TYPE = {
    [modelType.tv]: 'program',
    [modelType.recording]: 'recording',
    [modelType.recordingSeries]: 'recordingSeries',
    [modelType.vod]: 'movie',
    [modelType.series]: 'series',
    [modelType.season]: 'season',
    [modelType.episode]: 'episode'
} as const;
export const REVERSED_DETAIL_TYPE = {
    program: modelType.tv,
    recording: modelType.recording,
    recordingSeries: modelType.recordingSeries,
    movie: modelType.vod,
    series: modelType.series,
    season: modelType.season,
    episode: modelType.episode
} as const;

export const SERVICE_TYPE = {
    magio: 'GO',
    VOYO: 'VOYO',
    CANALPLUS: 'CANALPLUS'
};

const watchTvScreen = {
    'watch-tv': {
        path: 'watch-tv'
    }
};

const myRecordingsScreen = {
    'my-content': {
        path: 'recordings'
    }
};
const moviesAndSeries = {
    'movies-and-series': {
        path: 'movies-and-series'
    }
};

const documentaries = {
    documentaries: {
        path: 'documentaries'
    }
};

const freeSport = {
    'free-sport': {
        path: 'free-sport'
    }
};

const details = {
    Details: {
        path: 'detail/:type/:id/:platform?',
        parse: {
            type: (type: keyof typeof REVERSED_DETAIL_TYPE) => REVERSED_DETAIL_TYPE[type],
            platform: (type: keyof typeof SERVICE_TYPE) => SERVICE_TYPE[type],
            parentId: Number
        },
        stringify: {
            type: (type: keyof typeof DETAIL_TYPE) => DETAIL_TYPE[type],
            platform: (type: keyof typeof SERVICE_TYPE) => SERVICE_TYPE[type],
            parentId: Number
        }
    }
};

export const linkConfig = {
    screens: {
        Main: {
            // TO DO: each screen of Main has GetAppRouteConfigMap screens as well
            // that's why there is a problem with Details
            // Details is a child screen of Main screens but not Main itself
            screens: {
                home: {
                    path: 'home'
                },
                ...details,
                TvGuide: {
                    path: 'epg'
                },
                ViewAll: {
                    path: 'view-all'
                },
                ...watchTvScreen,
                ...myRecordingsScreen,
                videostore: {
                    path: 'magio-cinema',
                    screens: {
                        ...moviesAndSeries,
                        ...documentaries,
                        ...freeSport
                    }
                },
                'bbc-player': {
                    path: 'bbc'
                },
                special_voyo_1: {
                    path: 'voyo'
                },
                special_canalplus_1: {
                    path: 'canal-plus'
                },
                'dvtv-extra': {
                    path: 'dvtv'
                },
                settings: {
                    path: 'settings',
                    screens: {
                        manageFavorites: {
                            path: 'manage-favorites'
                        },
                        channelOrder: {
                            path: 'channel-order'
                        },
                        settings: {
                            path: 'settings'
                        }
                    }
                }
            }
        },
        // ...details, // detail accessing from stores location like videostore, voyo, canalplus...
        Login: {
            path: 'login'
        },
        Logout: {
            path: 'logout'
        },
        ErrorPage: {
            path: 'err'
        },
        PasswordManagement: {
            path: 'pwd-management'
        },
        ResetPin: {
            path: 'reset-pin'
        },
        Filter: {
            path: 'filter'
        },
        RecordPage: {
            path: 'recording-options'
        },
        CopyFavorites: {
            path: 'copy-favorites'
        },
        Onboarding: {
            path: 'onboarding'
        },
        InfoScene: {
            path: 'info'
        },
        SuspendScene: {
            path: 'suspend'
        },
        PreConsentScene: {
            path: 'pre-consent'
        },
        VoyoPromoScene: {
            path: 'voyo-promo'
        },
        PackageInfoScene: {
            path: 'package-info'
        },
        ConsentsIntroPage: {
            path: 'consents-intro'
        },
        SimpleNotification: {
            path: 'notification'
        }
    }
};
